import styled from 'styled-components';
import { device } from './deviceSize';

const Navbar = styled.div`
    background-color: #3b5998;
    width: 100%;
    height: 43px;
    font-family: 'Lato', sans-serif;
    color: white;
    font-size: 25px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const LogoContainer = styled.div`
    width: auto;
    height: 30px;
`;

const LogoImage = styled.img`
    height: 65%;
`;

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    /* justify-content: center; */
    align-items: center;
    flex-direction: column;
`;

const FormContainer = styled.div`
    margin-top: 15px;
    width: 418px;
    height: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* border: 1px solid green; */
    
    @media ${device.mobileL} {
        width: 93%;
    }
`;

const RzeczyInput = styled.input`
    width: 100%;
    height: 45px;
    background-color: #f5f6f7;
    padding-left: 12px;
    padding-right: 12px;
    font-size: 14px;
    border: none;
`;

const LogButton = styled.button`
    width: 418px;
    height: 38px;
    background-color: #1877f2;
    text-align: center;
    color: white;
    margin-top: 10px;
    border-radius: 5px;
    font-weight: bold;
    font-size: 14px;
    border: none;
    cursor: pointer;

    @media ${device.mobileL} {
        width: 100%;
    }
`;

const AlboContainer = styled.div`
    width: 100%;
    height: 30px;
    margin-top: 7px;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const Line = styled.span`
    border: 1px solid #ccd0d5;
    border-left: none;
    border-top: none;
    border-right: none;
    width: 50%;
`;

const Albo = styled.span`
    width: 50px;
    margin-left: 10px;
    margin-right: 10px;
    text-align: center;
    font-size: 14px;
`;

const CreateAcoountButton = styled.button`
    margin-top: 20px;
    background-color: #00a400;
    width: 162px;
    height: 37px;
    border: none;
    color: white;
    font-size: 14px;
    font-weight: bold;
    border-radius: 5px;
`;

const ForgotPassword = styled.a`
    margin-top: 15px;
    color: #7596c8;
    text-decoration: none;
    font-size: 14px;
`;

const TableContainer = styled.div`
    margin-top: 40px;
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

const TableLanguage = styled.table`
    margin: 4px 10px 0 0;
    width: 100%;
`;

const TableLanguageRow = styled.tr`

`;


const TableLanguageColumn = styled.th`
    font-size: 12px;
    color: #576b95;
    padding: 4px 0 0 0;
    font-weight: lighter;
`;

const FacebookFooter = styled.span`
    color: gray;
    font-size: 12px;
    padding-left: 15px;
`;

export {
    Navbar,
    LogoContainer,
    LogoImage,
    Container,
    FormContainer,
    RzeczyInput,
    LogButton,
    AlboContainer,
    Line,
    Albo,
    CreateAcoountButton,
    ForgotPassword,
    TableContainer,
    TableLanguage,
    TableLanguageRow,
    TableLanguageColumn,
    FacebookFooter
}